import { CheckCircle2, XCircle } from 'lucide-react'
import clsx from 'clsx'
import { formatDateTime } from '@/utils/format'
import type { PatchApproval } from '@/types/patching'
import styles from './Patching.module.css'

function shortHash(hash: string | null): string {
  return hash ? hash.slice(0, 12) : '—'
}

/** Immutable approval/rejection history for one environment. */
export function ApprovalsList({ approvals }: { approvals: PatchApproval[] }) {
  return (
    <div data-testid="approvals-list">
      {approvals.length === 0 ? (
        <p className={styles.muted}>No approval decisions recorded.</p>
      ) : (
        approvals.map((approval) => {
          const approved = approval.decision === 'approved'
          return (
            <div key={approval.id} className={styles.approval} data-decision={approval.decision}>
              <div className={styles.approvalHead}>
                <span className={clsx(styles.badge, approved ? styles.badgeDone : styles.badgeRejected)}>
                  {approved ? <CheckCircle2 size={11} /> : <XCircle size={11} />}
                  {approved ? 'Approved' : 'Rejected'}
                </span>
                <span className={styles.muted}>{formatDateTime(approval.created_at)}</span>
              </div>
              <div>{approval.approver}</div>
              {approval.notes && <div className={styles.muted}>“{approval.notes}”</div>}
              <div className={styles.hash} title={`scope ${approval.scope_hash} / plan ${approval.plan_hash ?? 'none'}`}>
                scope {shortHash(approval.scope_hash)} · plan {shortHash(approval.plan_hash)}
                {approval.acknowledged_additional_review ? ' · additional review acknowledged' : ''}
              </div>
            </div>
          )
        })
      )}
    </div>
  )
}
